/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { problemAlternativeDtoSchema } from "./problemAlternativeDtoSchema.ts";
import { problemDescriptionDtoSchema } from "./problemDescriptionDtoSchema.ts";
import { problemInNumbersRowDtoSchema } from "./problemInNumbersRowDtoSchema.ts";
import { problemQuoteDtoSchema } from "./problemQuoteDtoSchema.ts";
import { problemStakeholderDtoSchema } from "./problemStakeholderDtoSchema.ts";
import { z } from "zod/v4";

export const problemSectionDtoSchema = z.object({
  get description() {
    return problemDescriptionDtoSchema.optional();
  },
  get inNumbers() {
    return z.array(problemInNumbersRowDtoSchema).optional();
  },
  get stakeholders() {
    return z.array(problemStakeholderDtoSchema).optional();
  },
  get alternatives() {
    return z.array(problemAlternativeDtoSchema).optional();
  },
  get quotes() {
    return z.array(problemQuoteDtoSchema).optional();
  },
});
